// The player's own leaderboard row: by id, by wallet, or by the name they keep (names are unique; a browser's sessions share one row).
export const mineIndex = (rows, playerId, wallet, name) =>
  (rows ?? []).findIndex(r => r.playerId === playerId || (wallet && r.wallet === wallet) || (name && r.name === name));
